import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useAuth from 'providers/Auth/useAuth';

import logo from 'assets/images/logo.png';
import './Login.style.scss';

import LoginForm from 'components/pages/Login/form';
import LangSwitch from 'components/MainNav/LangSwitch';

const Login = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  return user ? (
    <Navigate to="/" />
  ) : (
    <div data-testid="login-container" className="Login">
      <div className="form">
        <div className="d-flex-end langSwitch">
          <LangSwitch />
        </div>
        <div className="logoContainer">
          <div className="recenterLogo logo m-auto d-block">
            <img className="resizeLogo" src={logo} alt="logo assolia" />
          </div>
        </div>
        <div className="container">
          <p data-testid="login-connection" className="text-center title">
            {t('button.login')}
          </p>
          <LoginForm />
        </div>
        <Link
          className="footer d-block text-center"
          onClick={() => localStorage.setItem('action_password', 'create')}
          to="/forgotPassword"
        >
          {t('button.firstLogin')}
        </Link>
      </div>
      <div className="img" />
    </div>
  );
};

export default Login;
